export default "__VITE_ASSET__DRQwqJfU__"